import { c as _c } from "react/compiler-runtime";
import { IconCheckOutline18 } from "nucleo-ui-outline-18";
import { Checkbox } from "@headlessui/react";
import { cn } from "../../lib/utils";
interface CheckBoxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  description?: string;
  disabled?: boolean;
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "brand";
}
export function CheckBox(t0) {
  const $ = _c(32);
  const {
    checked: t1,
    onChange,
    label,
    description,
    disabled: t2,
    className,
    size: t3,
    variant: t4
  } = t0;
  const checked = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  const size = t3 === undefined ? "md" : t3;
  const variant = t4 === undefined ? "default" : t4;
  let T0;
  let t10;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== checked || $[1] !== className || $[2] !== disabled || $[3] !== onChange || $[4] !== size || $[5] !== variant) {
    const sizeClasses = {
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-6 w-6"
    };
    const iconSizeClasses = {
      sm: "h-3 w-3",
      md: "h-3.5 w-3.5",
      lg: "h-4 w-4"
    };
    const variantClasses = {
      default: {
        unchecked: "border-ds-border-default bg-ds-surface-card",
        checked: "border-ds-text-primary bg-ds-text-primary",
        disabled: "border-ds-border-default bg-ds-surface-muted opacity-50",
        icon: "text-ds-surface-card"
      },
      brand: {
        unchecked: "border-ds-border-default bg-ds-surface-card",
        checked: "border-ds-brand-500 bg-ds-brand-500",
        disabled: "border-ds-border-default bg-ds-surface-muted opacity-50",
        icon: "text-white"
      }
    };
    const getCheckboxClasses = () => {
      if (disabled) {
        return variantClasses[variant].disabled;
      }
      return checked ? variantClasses[variant].checked : variantClasses[variant].unchecked;
    };
    if ($[13] !== className) {
      t10 = cn("flex items-start gap-3", className);
      $[13] = className;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    T0 = Checkbox;
    t5 = checked;
    t6 = onChange;
    t7 = disabled;
    t8 = cn("group relative flex-shrink-0 rounded border transition-all duration-200", "focus:border-ds-brand-500 focus:outline-none focus:ring-0", "hover:border-ds-brand-500 hover:shadow-sm", "disabled:hover:border-ds-border-default disabled:cursor-not-allowed", sizeClasses[size], getCheckboxClasses());
    t9 = checked && <IconCheckOutline18 className={cn("absolute inset-0 m-auto transition-all duration-200", variantClasses[variant].icon, iconSizeClasses[size])} />;
    $[0] = checked;
    $[1] = className;
    $[2] = disabled;
    $[3] = onChange;
    $[4] = size;
    $[5] = variant;
    $[6] = T0;
    $[7] = t10;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    T0 = $[6];
    t10 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t11;
  if ($[15] !== T0 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t11 = <T0 checked={t5} onChange={t6} disabled={t7} className={t8}>{t9}</T0>;
    $[15] = T0;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== checked || $[23] !== description || $[24] !== disabled || $[25] !== label || $[26] !== onChange) {
    t12 = (label || description) && <div className="flex flex-col gap-1">{label && <label className={cn("text-ds-text-primary cursor-pointer select-none text-sm font-medium", disabled && "cursor-not-allowed opacity-50")} onClick={() => !disabled && onChange?.(!checked)}>{label}</label>}{description && <p className={cn("text-ds-text-muted text-xs", disabled && "opacity-50")}>{description}</p>}</div>;
    $[22] = checked;
    $[23] = description;
    $[24] = disabled;
    $[25] = label;
    $[26] = onChange;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12) {
    t13 = <div className={t10}>{t11}{t12}</div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
}